/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RiskIDRequestBody,
  RiskIDRequestBody$Outbound,
  RiskIDRequestBody$outboundSchema,
} from "../components/riskidrequestbody.js";

export type UnmaskRiskResultSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UnmaskRiskResultSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UnmaskRiskResultSecurity = {
  option1?: UnmaskRiskResultSecurityOption1 | undefined;
  option2?: UnmaskRiskResultSecurityOption2 | undefined;
};

export type UnmaskRiskResultRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  riskIDRequestBody: RiskIDRequestBody;
};

/** @internal */
export type UnmaskRiskResultSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UnmaskRiskResultSecurityOption1$outboundSchema: z.ZodMiniType<
  UnmaskRiskResultSecurityOption1$Outbound,
  UnmaskRiskResultSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function unmaskRiskResultSecurityOption1ToJSON(
  unmaskRiskResultSecurityOption1: UnmaskRiskResultSecurityOption1,
): string {
  return JSON.stringify(
    UnmaskRiskResultSecurityOption1$outboundSchema.parse(
      unmaskRiskResultSecurityOption1,
    ),
  );
}

/** @internal */
export type UnmaskRiskResultSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UnmaskRiskResultSecurityOption2$outboundSchema: z.ZodMiniType<
  UnmaskRiskResultSecurityOption2$Outbound,
  UnmaskRiskResultSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function unmaskRiskResultSecurityOption2ToJSON(
  unmaskRiskResultSecurityOption2: UnmaskRiskResultSecurityOption2,
): string {
  return JSON.stringify(
    UnmaskRiskResultSecurityOption2$outboundSchema.parse(
      unmaskRiskResultSecurityOption2,
    ),
  );
}

/** @internal */
export type UnmaskRiskResultSecurity$Outbound = {
  Option1?: UnmaskRiskResultSecurityOption1$Outbound | undefined;
  Option2?: UnmaskRiskResultSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UnmaskRiskResultSecurity$outboundSchema: z.ZodMiniType<
  UnmaskRiskResultSecurity$Outbound,
  UnmaskRiskResultSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UnmaskRiskResultSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UnmaskRiskResultSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function unmaskRiskResultSecurityToJSON(
  unmaskRiskResultSecurity: UnmaskRiskResultSecurity,
): string {
  return JSON.stringify(
    UnmaskRiskResultSecurity$outboundSchema.parse(unmaskRiskResultSecurity),
  );
}

/** @internal */
export type UnmaskRiskResultRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  RiskIDRequestBody: RiskIDRequestBody$Outbound;
};

/** @internal */
export const UnmaskRiskResultRequest$outboundSchema: z.ZodMiniType<
  UnmaskRiskResultRequest$Outbound,
  UnmaskRiskResultRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    riskIDRequestBody: RiskIDRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      riskIDRequestBody: "RiskIDRequestBody",
    });
  }),
);

export function unmaskRiskResultRequestToJSON(
  unmaskRiskResultRequest: UnmaskRiskResultRequest,
): string {
  return JSON.stringify(
    UnmaskRiskResultRequest$outboundSchema.parse(unmaskRiskResultRequest),
  );
}
